var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2003_4408",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 24,
    height: 24,
    transform: "rotate(90 24 0)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2003_4408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6882 5.27668C15.8961 5.46113 16 5.67953 16 5.93186C16 6.1837 15.8961 6.40184 15.6882 6.5863L9.59815 11.9908L15.709 17.4137C15.903 17.5859 16 17.8011 16 18.0593C16 18.3175 15.8961 18.5389 15.6882 18.7233C15.4804 18.9078 15.2343 19 14.9499 19C14.6661 19 14.4203 18.9078 14.2125 18.7233L7.22864 12.5072C7.1455 12.4335 7.08647 12.3535 7.05155 12.2675C7.01718 12.1814 7 12.0892 7 11.9908C7 11.8924 7.01718 11.8002 7.05155 11.7141C7.08647 11.628 7.1455 11.5481 7.22864 11.4743L14.2333 5.25824C14.4273 5.08608 14.6661 5 14.9499 5C15.2343 5 15.4804 5.09223 15.6882 5.27668Z",
    fill: "#7B7B7B"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeta);
export default __webpack_public_path__ + "static/media/seta.17b71b382dd52edbc88b85e36d6589a8.svg";
export { ForwardRef as ReactComponent };